import Events from "../models/Events";

const EventStore = Events.create();

export default EventStore;
